import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../common/Auth"
import WhoWeAreEditIcon from "../../pages/whoWeAre/WhoWeAreEditIcon"
import { processForMobile } from './SectionTitle'

const SectionTitleWithText = () => {

  const { themeSettingsData } = useContext(AuthContext)
  const [aboutData, setAboutData] = useState({})
  const [aboutId, setAboutId] = useState("")

  useEffect(() => {
    themeSettingsData.length > 0 &&
      themeSettingsData.map((i) => {
        if (i.settingsName === 'whoWeAre') {
          setAboutData(i?.values[0])
          setAboutId(i?._id)
        }
      })
  }, [themeSettingsData])


  let titleStyle = {
    color: aboutData.titleColor,
    fontFamily: aboutData.titleFont,
    fontSize: aboutData.titleFontSize != 0 ? aboutData.titleFontSize + "px" : ""

  }

  let subTitleStyle = {
    color: aboutData.subTitleColor,
    fontFamily: aboutData.subTitleFont,
    fontSize: aboutData.subTitleFontSize != 0 ? aboutData.subTitleFontSize + "px" : ""

  }

  let descStyle = {
    color: aboutData.discriptionColor,
    fontFamily: aboutData.discriptionFont,
    fontSize: aboutData.discriptionFontSize != 0 ? aboutData.discriptionFontSize + "px" : ""

  }
  let pt = aboutData.paddingTop ? aboutData.paddingTop : "pt-0";
  let pb = aboutData.paddingBottom ? aboutData.paddingBottom : "pb-0";
  let mb = aboutData.marginBottom ? aboutData.marginBottom : "mt-50";
  let mt = aboutData.marginTop ? aboutData.marginTop : "mb-50";
  let mr = aboutData.marginRight ? aboutData.marginRight : "mr-0";
  let ml = aboutData.marginLeft ? aboutData.marginLeft : "ml-0";
  let pl = aboutData.paddingLeft ? aboutData.paddingLeft : "pl-0";
  let pr = aboutData.paddingRight ? aboutData.paddingRight : "pr-0";
  let fullSection = aboutData.fullSection ? "container-fluid" : "container";
  let bgImage = aboutData?.bgImage ? aboutData?.bgImage : "";
  let bgColor = aboutData?.bgColor ? aboutData?.bgColor : "";

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );



  return (
    <div className={`antera-who-we-are-section-container welcome-area section-bgImage ${pt} ${pb} ${mb} ${mt} ${mr} ${ml} ${pl} ${pr} `}  style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}}>
      <div className={`antera-who-we-are-section-content-container ${fullSection}`}>
        <div className="welcome-content text-center">
          {Object.keys(aboutData).length > 0 ? <>
            <div className="edit-inline">
              <WhoWeAreEditIcon aboutId={aboutId} fromEditAction="topBottomspace" />
            </div>
            <div className="edit-inline">
              <WhoWeAreEditIcon aboutId={aboutId} fromEditAction="title" />
            </div>
            <div className="w-100 px-sm-4 about-title">
              {aboutData.title && (
                <h5 className="antera-who-we-are-section-title w-100" dangerouslySetInnerHTML={{ __html: isMobile ? processForMobile(aboutData.title) : aboutData.title}}></h5>
              )}
            </div>
            <div className="edit-inline">
              <WhoWeAreEditIcon aboutId={aboutId} fromEditAction="subTitle" />
            </div>
            <div className="w-100 about-title">
              {aboutData.subTitle && (
                <h1 className="antera-who-we-are-section-subtitle w-100" dangerouslySetInnerHTML={{ __html: isMobile ?  processForMobile(aboutData.subTitle) : aboutData.subTitle}}></h1>
              )}
            </div>

            <div className="edit-inline">
              <WhoWeAreEditIcon aboutId={aboutId} fromEditAction="description" />
            </div>
            <div className="w-100 about-description">
              {aboutData.discription && (
                <p className="antera-who-we-are-section-description w-100" dangerouslySetInnerHTML={{ __html: isMobile ?  processForMobile(aboutData.discription) : aboutData.discription }}></p>
              )}</div>
          </> : <>
            <h3>Create Who We are section at admin side</h3>
          </>}


        </div>
      </div>
    </div>
  );
};

SectionTitleWithText.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default SectionTitleWithText;
